/**
 * Calcultes the db value and rounds the result
 * https://stackoverflow.com/a/18358056
 *
 * @param {Number} margin
 * @param {Number} revenue
 *
 * @returns {Number}
 */
export const calculateDB = (margin, revenue) => {
  if (!revenue) return null
  const dbValue = (margin / revenue) * 100

  return +(Math.round(dbValue + "e+2") + "e-2")
}

/**
 * Calculates the revenue difference between current year and previous year
 *
 * @param {Number} currentYearRevenue
 * @param {Number} lastYearRevenue
 *
 * @returns {Number}
 */
export const calculateGrowth = (currentYearRevenue, lastYearRevenue) => {
  if (!currentYearRevenue || !lastYearRevenue) return null
  const difference = currentYearRevenue - lastYearRevenue
  const percentage = (difference / lastYearRevenue) * 100

  return +(Math.round(percentage + "e+2") + "e-2")
}

export const calculateDeviation = (currentYearRevenue, currentYearRevenueTarget) => {
  if (!currentYearRevenue || !currentYearRevenueTarget) return null
  const difference = currentYearRevenue - currentYearRevenueTarget

  return +(Math.round(difference + "e+2") + "e-2")
}

/**
 * Rounds the value to 2 decimal digits
 *
 * @param {number|string} value
 * @returns {number}
 */
export const applyRounding = (value) => {
  return +(Math.round(Number(value) + "e+2") + "e-2")
}
